import AccountingSubject from './AccountingSubject';

export default AccountingSubject;
